export const createSemanticSelectStyles = colors => ({
  control: (baseStyles, state) => ({
    ...baseStyles,
    backgroundColor: colors.semantic.surface.card,
    borderColor: state.isFocused
      ? colors.semantic.action.primary
      : colors.semantic.border.default,
    boxShadow: state.isFocused
      ? `0 0 0 0.2rem ${colors.semantic.surface.selection}`
      : 'none',
    ':hover': {
      ...baseStyles[':hover'],
      borderColor: colors.semantic.action.primary,
    },
  }),
  valueContainer: baseStyles => ({
    ...baseStyles,
    color: colors.semantic.text.primary,
  }),
  input: baseStyles => ({
    ...baseStyles,
    color: colors.semantic.text.primary,
    WebkitTextFillColor: colors.semantic.text.primary,
  }),
  singleValue: baseStyles => ({
    ...baseStyles,
    color: colors.semantic.text.primary,
  }),
  placeholder: baseStyles => ({
    ...baseStyles,
    color: colors.semantic.text.secondary,
  }),
  menu: baseStyles => ({
    ...baseStyles,
    backgroundColor: colors.semantic.surface.card,
    border: `1px solid ${colors.semantic.border.default}`,
  }),
  option: (baseStyles, state) => {
    if (state.isDisabled) {
      return {
        ...baseStyles,
        color: colors.semantic.text.secondary,
        backgroundColor: colors.semantic.surface.card,
        opacity: 0.5,
        cursor: 'not-allowed',
        pointerEvents: 'auto',
      };
    }

    let backgroundColor = colors.semantic.surface.card;
    let activeBackgroundColor = colors.semantic.surface.muted;

    if (state.isSelected) {
      backgroundColor = colors.semantic.surface.selection;
      activeBackgroundColor = colors.semantic.surface.selection;
    } else if (state.isFocused) {
      backgroundColor = colors.semantic.surface.muted;
    }

    return {
      ...baseStyles,
      color: colors.semantic.text.primary,
      backgroundColor,
      ':active': {
        ...baseStyles[':active'],
        backgroundColor: activeBackgroundColor,
      },
    };
  },
});

export const mergeSelectStyles = (baseStyles, customStyles) => {
  if (!customStyles) {
    return baseStyles;
  }

  const mergedStyles = {
    ...baseStyles,
    ...customStyles,
  };

  Object.keys(baseStyles).forEach(styleKey => {
    if (customStyles?.[styleKey]) {
      mergedStyles[styleKey] = (baseStyleArgs, state) => {
        const baseResult = baseStyles[styleKey](baseStyleArgs, state);
        return customStyles[styleKey](baseResult, state);
      };
    }
  });

  return mergedStyles;
};
